import DefaultFormInputs from './DefaultFormInputs';
import TiFormInputs from './TiFormInputs';
import generateRender from 'shared/utils/generateRender';

const FormInputs = generateRender({
    default: DefaultFormInputs,
    ti: TiFormInputs
})

export default FormInputs;